import { atom } from '@reatom/framework'

import { PATHFINDER_API_URL } from '@root/shared'

import { createPathfinderSwapService } from '../services/pathfinder-swap-service'

import type { PathfinderSwapService } from '../services/pathfinder-swap-service'

const DEV_PROXY_URL = '/__pathfinder'

const isDev = import.meta.env.DEV
const usesTestPathfinder = PATHFINDER_API_URL.includes(
  'test-pathfinder.di.cash',
)

const resolvedBaseUrl = (() => {
  if (isDev && (PATHFINDER_API_URL.length === 0 || usesTestPathfinder)) {
    return DEV_PROXY_URL
  }
  return PATHFINDER_API_URL
})()

let cached: PathfinderSwapService | undefined

export const pathfinderServiceAtom = atom<PathfinderSwapService | undefined>(
  (_ctx) => {
    if (resolvedBaseUrl.length === 0) {
      return undefined
    }
    if (!cached) {
      cached = createPathfinderSwapService({ baseUrl: resolvedBaseUrl })
    }
    return cached
  },
  'pathfinderServiceAtom',
)
